export const GETNOTIFICATIONS = {
  REQUEST: 'Notifications/Request',
  SUCCESS: 'Notifications/Success',
  FAILURE: 'Notifications/Failure'
}

export const RESETNOTIFICATIONS = {
  SUCCESS: 'Notifications/Reset'
}